import React, { createRef, ReactNode, useEffect, useState } from "react";
import XIcon from "../assets/icons/xIcon";

import "./popUp.css";

interface PopUpProps {
    title?: string;
    subtitle?: string;
    children: any;
    className?: string;
    width?: number;
    height?: number;
    setWidth?: (v: number) => void;
    setHeight?: (v: number) => void;
    onClose?: () => void;
}

export default function PopUp(props: PopUpProps) {

    const boxRef = createRef<HTMLDivElement>();

    useEffect(() => {
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return () => {
            window.removeEventListener("resize", updateDimensions);
        }
    }, [boxRef]);

    function updateDimensions() {
        if(props.setWidth && boxRef.current) {
            props.setWidth(boxRef.current.offsetWidth)
        }
        if(props.setHeight && boxRef.current) {
            props.setHeight(boxRef.current.offsetWidth)
        }
    }

    return <div className={"popup" + (props.className ? " " + props.className : "")}>
        <div ref={boxRef} className="popup-box" style={{
            width: props.width ? "calc(" + props.width + "px - 2*var(--padding-inline))" : "",
            height: props.height ? "calc(" + props.height + "px - 2*var(--padding-block))" : ""
        }}>
            {props.title ? <div className="header">
                <h2>
                    {props.title}
                    {props.subtitle ? <h4 className="subtitle">{props.subtitle}</h4> : <></>}
                </h2>
                
                <div onClick={() => {
                    if(props.onClose) props.onClose();
                    closePopUp();
                }} className="close">
                    <XIcon/>
                </div>
            </div> : <></>}
            <div className="content">
                {props.children}
            </div>
        </div>
    </div>
}

export function openPopUp(el: ReactNode) {
    window.dispatchEvent(new CustomEvent("openPopUp", {detail: el}));
}

export function closePopUp() {
    window.dispatchEvent(new CustomEvent("openPopUp", {detail: <></>}));
}

export function PopUpWrapper() {
    const [currentPopUp, setCurrentPopUp] = useState<ReactNode>(<></>);
    useEffect(() => {
        window.addEventListener("openPopUp", handleEvent);
        return () => {
            window.removeEventListener("openPopUp", handleEvent);
        }
    })


    function handleEvent(e: CustomEventInit<ReactNode>) {
        setCurrentPopUp(e.detail);
    }

    return <>{currentPopUp}</>;
}